






import { Component, Vue } from 'vue-property-decorator'

@Component({
    name: 'PriceList'
  })
export default class PriceList extends Vue {
}
